import React from 'react';
import classes from  './Header.css';

const header = (props) =>{

    let message = `Player ${props.turn} 's Turn`;

    if(props.gameEnd && props.matchWonBy === 'nobody'){
        const messageArray =  [`Looks like we have a stalemate`,`Another draw in the TIC TAC TOE challenge`,`You two are too evenly matched!`, `I sense some sorth of telepathy going on here`]
        const random = Math.floor(Math.random() * messageArray.length);  
        message = messageArray[random];
    }
     if(props.gameEnd && props.matchWonBy !== 'nobody'){
        message = `Match Won By Player ${props.matchWonBy}`;

    }

        return (
            <div className={classes.header}>
                 <div className={classes.header__title}>    {props.gameEnd ? `GAME OVER` : `Greatest TIC TAC TOE in the GALAXY`} </div>
                 <div className={classes.header__secondary}> 
                      {/* {props.gameEnd ? `Match Won By Player ${props.matchWonBy}` : `Player ${props.turn} 's move`} */}
                      {message}
                 </div>
            </div>

        )
}

export default header;


// WEBPACK FOOTER //
// ./src/layout/Header/Header.js